window.addEventListener('load', () => {
    function loadAuthWidget(options) {
        let isListenerAttached = false;
        const widgets = document.querySelectorAll(options.component);

        [...widgets].forEach(widget => {
            widget.addEventListener('click', () => {
                if (m.widgets.isLoaded()) {
                    return;
                }

                if (!isListenerAttached) {
                    m.widgets.load();

                    document.addEventListener(options.triggerEvent, () => {
                        widget.firstChild.click();
                    }, { once: true, passive: true });

                    isListenerAttached = true;
                }
            });
        });
    }

    /**
     * Load Web Component's scripts.
     * @param { string} param - The URI dialog parameter.
     */
    function loadAuthWidgetByDialogParam(param) {
        const regex = new RegExp('dialog=' + param);

        if (location.search.match(regex) && !m.widgets.isLoaded()) {
            m.widgets.load();
        }
    }

    /**
     * Show Auth Form for non-authorized users by redirectUrl parameter.
     */
    function showAuthFormByRedirectParam() {
        const redirectUrlPattern = 'redirectUrl=';
        const webinarInvitationQueryParam = 'webinar_invitation';
        const newCustomerQueryParam = 'new_customer';
        const isLoggedIn = document.body.classList.contains('register');
        const hasRedirectUrl = location.search.includes(redirectUrlPattern);
        const registrationRequired = location.search.includes(webinarInvitationQueryParam) && location.search.includes(newCustomerQueryParam);

        if (isLoggedIn) {
            return;
        }

        if (registrationRequired) {
            return openSignUpForm();
        }

        if (hasRedirectUrl) {
            openLoginForm();
        }
    }

    /**
     * Show SignUp Form for non-authorized users by redirectUrl parameter.
     */
    function showSignUpFormByRedirectParam() {
        const regex = new RegExp('dialog=open-account');
        const isLoggedIn = document.body.classList.contains('register');

        if (!isLoggedIn && location.search.match(regex)) {
            openSignUpForm();
        }
    }

    /**
     * Navigate to Webinars
     */
    function navigateToWebinarsByRedirectParam() {
        const regex = new RegExp('external_webinar_invitation');
        if(!location.search.match(regex)) {
            return;
        }

        const webinarUrl = 'https://worldcapital1.clickmeeting.com/world-capital1';
        const isLoggedIn = document.body.classList.contains('register');

        if(isLoggedIn) {
            return window.location.href = webinarUrl;
        }

        openSignUpForm();
    }

    function openLoginForm() {
        const login = document.querySelector('ngp-auth-login');

        if (!m.widgets.isLoaded()) {
            m.widgets.load();

            document.addEventListener('ngpLoginWidgetReady', () => {
                login.firstChild.click();
            }, { once: true, passive: true });
        } else {
            login.firstChild.click();
        }
    }

    function openSignUpForm() {
        const signup = document.querySelector('ngp-auth-signup');

        if (!m.widgets.isLoaded()) {
            m.widgets.load();

            document.addEventListener('ngpSignupWidgetReady', () => {
                signup.firstChild.click();
            }, { once: true, passive: true });
        } else {
            signup.firstChild.click();
        }
    }

    showAuthFormByRedirectParam();
    showSignUpFormByRedirectParam();
    navigateToWebinarsByRedirectParam();
    loadAuthWidgetByDialogParam('login');
    loadAuthWidgetByDialogParam('password-reset');
    loadAuthWidget({ component: 'ngp-auth-login', triggerEvent: 'ngpLoginWidgetReady' });
    loadAuthWidget({ component: 'ngp-auth-logout', triggerEvent: 'ngpLogoutWidgetReady' });
    loadAuthWidget({ component: 'ngp-auth-signup', triggerEvent: 'ngpSignupWidgetReady' });
});
